import Enums from '../../theme/enums';

/**
 * Component used to display any sort of text. Can apply set colors,
 * sizes, weights, and decorations keeping text consistent within an
 * application.
 */
export default {
  computed: {
    classes() {
      let c = [];
      c.push(this.generateClassName('weight', this.weight));
      c.push(this.generateClassName('size', this.size));
      c.push(this.generateClassName('color', this.color));
      c.push(this.generateClassName('bgColor', this.bgColor));
      c.push(this.generateClassName('textDec', this.textDec));
      c.push(this.generateClassName('textLeading', this.textLeading));
      if (this.hasEllipsis) c.push('truncate inline-block');
      if (this.isDisabled) c.push('nui-fa-disabled');

      return c.join(' ');
    }
  },

  methods: {
    generateClassName(prop, val) {
      switch (prop) {
        case 'weight':
          return Enums.textWeightClasses[val]
            ? Enums.textWeightClasses[val]
            : '';
        case 'size':
          return Enums.textSizeClasses[val] ? Enums.textSizeClasses[val] : '';
        case 'color':
          return Enums.textColorClasses[val] ? Enums.textColorClasses[val] : '';
        case 'bgColor':
          return Enums.bgColorClasses[val] ? Enums.bgColorClasses[val] : '';
        case 'textDec':
          return Enums.textDecClasses[val] ? Enums.textDecClasses[val] : '';
        case 'textLeading':
          return Enums.textleadingClasses[val]
            ? Enums.textleadingClasses[val]
            : '';
        default:
          return '';
      }
    }
  }
};
